import { Component, Input, OnInit } from '@angular/core';
import { WTNScaleProps } from '@clubspark/wtn-component-library/build/WTNScale/WTNScale.types';
import type { ComponentProps } from 'react';

@Component({
    selector: 'app-wtn-card',
    styleUrls: ['./wtn.component.scss'],
    templateUrl: './wtn.component.html',
})
export class WtnComponent implements OnInit {
    WtnScale = () => import('@clubspark/wtn-component-library').then((m) => m.WTNScale);
    WtnScaleProps: WTNScaleProps = {
        width: 360,
        infoModal: false,
        wtnSingles: 0,
        wtnDoubles: 0,
        mode: '',
    };

    @Input('id') id: string;
    @Input('single-percentage') singlePercentage: number;
    @Input('single-progress') singleProgress: number;
    @Input('dobles-percentage') doublesPercentage: number;
    @Input('dobles-progress') doublesProgress: number;
    @Input('only-results') onlyResults: boolean = false;

    roundedSinglePercentage: number = 0;
    roundedDoublesPercentage: number = 0;
    constructor() {}

    ngOnInit() {
        this.roundedSinglePercentage = Math.round(this.singlePercentage);
        this.roundedDoublesPercentage = Math.round(this.doublesPercentage);

        this.singlePercentage = this.singlePercentage ? Number(Number(this.singlePercentage).toFixed(1)) : 0;
        this.singleProgress = this.singleProgress || 0;

        this.doublesPercentage = this.doublesPercentage ? Number(Number(this.doublesPercentage).toFixed(1)) : 0;
        this.doublesProgress = this.doublesProgress || 0;

        this.WtnScaleProps.wtnSingles = this.singlePercentage;
        this.WtnScaleProps.wtnDoubles = this.doublesPercentage;
    }
}
